import styled from 'styled-components'

export const Wrapper = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.space['8'],
  justifyContent: 'space-between',
}))

export const Trigger = styled.button<{ $open: boolean }>(({ theme, $open }) => ({
  '&:disabled': {
    cursor: 'not-allowed',
    opacity: 0.5,
  },
  alignItems: 'center',
  backgroundColor: theme.colors.white,
  border: `${theme.border.size['1']} solid ${$open ? theme.colors.black500 : theme.colors.gray500}`,
  borderRadius: theme.border.radius['8'],
  color: theme.colors.black500,
  cursor: 'pointer',
  display: 'flex',
  gap: theme.space['4'],
  height: '3.2rem',
  padding: `0 ${theme.space['8']}`,
}))

export const Popover = styled.div(({ theme }) => ({
  backgroundColor: theme.colors.white,
  border: `${theme.border.size['1']} solid ${theme.colors.gray500}`,
  borderRadius: theme.border.radius['12'],
  boxShadow: theme.shadow.md,
  padding: theme.space['12'],
  zIndex: theme.zIndex.level3,
}))

export const Grid = styled.div(({ theme }) => ({
  display: 'grid',
  gap: theme.space['8'],
  gridTemplateColumns: 'repeat(7, 2.4rem)',
}))

// Note: the default swatch is hatched, since its colour is the neutral gray, not a picked one
export const Swatch = styled.button<{ $color: string; $default: boolean; $selected: boolean }>(
  ({ theme, $color, $default, $selected }) => ({
    background: $default ? theme.colors.gray800 : $color,
    border: `${theme.border.size['2']} solid ${$selected ? theme.colors.black800 : 'transparent'}`,
    borderRadius: '50%',
    boxShadow: `inset 0 0 0 ${theme.border.size['2']} ${theme.colors.white}`,
    cursor: 'pointer',
    flexShrink: 0,
    height: '2.4rem',
    padding: 0,
    transition: `background-color ${theme.transition.duration.md}, border-color ${theme.transition.duration.md}`,
    width: '2.4rem',
  }),
)

// Note: the native color input sits invisibly over the swatch, so a click opens the browser color picker
export const CustomSwatch = styled.label<{ $color: string; $selected: boolean }>(
  ({ theme, $color, $selected }) => ({
    background: $color || 'conic-gradient(red, yellow, lime, aqua, blue, magenta, red)',
    border: `${theme.border.size['2']} solid ${$selected ? theme.colors.black800 : 'transparent'}`,
    borderRadius: '50%',
    boxShadow: `inset 0 0 0 ${theme.border.size['2']} ${theme.colors.white}`,
    cursor: 'pointer',
    flexShrink: 0,
    height: '2.4rem',
    position: 'relative',
    transition: `background-color ${theme.transition.duration.md}, border-color ${theme.transition.duration.md}`,
    width: '2.4rem',
  }),
)

export const ColorInput = styled.input({
  cursor: 'pointer',
  height: '100%',
  inset: 0,
  opacity: 0,
  position: 'absolute',
  width: '100%',
})

// Note: the custom color sits apart from the palette, under its own title
export const CustomSection = styled.div(({ theme }) => ({
  borderTop: `${theme.border.size['1']} solid ${theme.colors.gray500}`,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['8'],
  marginTop: theme.space['12'],
  paddingTop: theme.space['12'],
}))

export const CustomRow = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.space['8'],
}))
